import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PageHeader } from "@/components/PageHeader";
import { Calendar, ArrowRight } from "lucide-react";

export const Route = createFileRoute("/admin/administrateur/consultations/")({
  component: ConsultationsAdmin,
});

function ConsultationsAdmin() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 p-6">
      <PageHeader
        title="Consultations"
        description="Vue administrative des consultations actives et agenda"
        domain="clinical"
      />
      <Card className="bg-slate-900/60 border-slate-800 mt-4">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2">
            <Calendar className="h-4 w-4 text-sky-400" /> Rendez-vous aujourd'hui
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <Link to="/consultation" className="block">
              <div className="bg-slate-950/40 hover:bg-slate-800/60 transition rounded-lg p-3 border border-slate-800">
                <div className="text-xs font-semibold">Démarrer une consultation</div>
                <div className="text-[10px] text-slate-500">Notes + IA ICD-10 + Prescription</div>
                <ArrowRight className="h-3 w-3 text-slate-500 mt-2" />
              </div>
            </Link>
            <Link to="/patients" className="block">
              <div className="bg-slate-950/40 hover:bg-slate-800/60 transition rounded-lg p-3 border border-slate-800">
                <div className="text-xs font-semibold">Vue patient</div>
                <div className="text-[10px] text-slate-500">Liste + dossiers actifs</div>
                <ArrowRight className="h-3 w-3 text-slate-500 mt-2" />
              </div>
            </Link>
            <Link to="/e-notes" className="block">
              <div className="bg-slate-950/40 hover:bg-slate-800/60 transition rounded-lg p-3 border border-slate-800">
                <div className="text-xs font-semibold">E-Notes</div>
                <div className="text-[10px] text-slate-500">FSE + ALD + Dentaire</div>
                <ArrowRight className="h-3 w-3 text-slate-500 mt-2" />
              </div>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
